module.exports = __webpack_public_path__ + "img/v3.1.23f0e5c5.png";